const trackingActions = {
  NOTIFICATION_DIALOG_SHOWN: "NOTIFICATION_DIALOG_SHOWN",
  NOTIFICATION_DIALOG_DISMISSED: "NOTIFICATION_DIALOG_DISMISSED",
  NOTIFICATION_DIALOG_ACCEPTED: "NOTIFICATION_DIALOG_ACCEPTED",
  READ_ALOUD_CLICKED_NEWS_POST: "READ_ALOUD_CLICKED_NEWS_POST",
  TRANSLATE_CLICKED_NEWS_POST: "TRANSLATE_CLICKED_NEWS_POST",
};

export default trackingActions;
